import { Component, Output, Input, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'upsell-buttons',
  templateUrl: 'upsell-buttons.html',
  styleUrls: ['upsell-buttons.scss'],
})
export class UpsellButtonsComponent {
  @Input() buttonYesText = `YES I WANT THIS SPECIAL ADDED TO MY ORDER`;
  @Input() showbuttonYesText = true;
  @Input() buttonNoText = '';
  @Input() showbuttonNoText = true;
  @Input() description: string = '';
  @Input() showDescription: boolean = false;
  @Input() image: string = '';
  @Input() imageAlt: string = '';
  @Input() showImage: boolean = true;
  @Input() upsellCtaTextButtonsClass: string;

  //Provide external method to navigate to next page over funnel
  @Output() eventEmitter: EventEmitter<boolean> = new EventEmitter();

  public buttonValue = false;

  constructor(FormsModule: FormsModule
     ) {}

  nextPage(buttonValue: boolean) {
    this.buttonValue = buttonValue ? true : false;
    this.eventEmitter.emit(this.buttonValue);
  }
}
